<section class="modules">
  <search-box (update)="searchValue = $event"></search-box>

  <area-box-list [researched]="searchValue"></area-box-list>
</section>
